import React from "react";
import GoBack from "shared/ui/GoBack";
import ProfileContent from "widgets/ProfileContent";

const Profile: React.FC = () => {
  return (
    <main>
      <GoBack black />

      <ProfileContent />
    </main>
  );
};

export default Profile;
